<template>

  <div>

    <img src="../assets/rock.jpg"></img>

    <p>
      I write code and music at the University of Maryland.
    </p>

    <ul>
      <li><a href="//johannmiller.com/resume.pdf">resume</a></li>
      <li><a href="//github.com/johannkm">github</a></li>
      <li><a href="//www.linkedin.com/in/johannkm/">linkedin</a></li>

    </ul>

  </div>

</template>

<script>

export default{
  name: 'home-page',
  created: function(){
    console.log("created")
  },
  mounted: function(){
    console.log("mounted")
  }
}

</script>

<style scoped>

ul {
  list-style: none;
  padding: 0;
}

img {
  width: 100%;
  border-radius: 0.2%;
  margin-top: 1.45em;
  padding-bottom: 15px;
  -webkit-filter: grayscale(0.3); /* Google Chrome, Safari 6+ & Opera 15+ */
  filter: grayscale(0.3); /* Microsoft Edge and Firefox 35+ */
}

</style>



// WEBPACK FOOTER //
// HomePage.vue?a5df79e2